import { schema } from "normalizr";
export const clientActivity = new schema.Entity("agent");
export const clientActivitiesSchema = new schema.Entity("clientActivities", {
  clientActivities: [clientActivity]
}, {
  idAttribute: "clientActivityId"
});